import { statusBoard } from "@/mocks/homeMeta";
import SectionHeading from "./SectionHeading";
import { toneBar, toneIcon } from "./tones";

export default function StatusBoard() {
  return (
    <section id="board" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          index="01"
          eyebrow="Truth Board"
          title="真假看板：每条信息都标着当前状态"
          desc="不想被带跑，先看清一件事走到哪一步。已辟谣、出现反转、待核实、持续更新，四种状态分别对应不同的证据强度，每天早晚各刷新一次。"
          actionLabel="查看全部标注规则"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {statusBoard.map((item) => (
            <article
              key={item.key}
              className="group rounded-lg bg-background-50 border border-background-200 hover:border-background-300 transition-colors p-5 flex flex-col"
            >
              <div className="flex items-start justify-between">
                <span
                  className={`w-11 h-11 rounded-md flex items-center justify-center ${toneIcon[item.tone]}`}
                >
                  <i className={`${item.icon} text-xl w-5 h-5 flex items-center justify-center`} />
                </span>
                <span className="text-[11px] font-label text-foreground-500 bg-background-100 border border-background-200 rounded-full px-2 py-1 whitespace-nowrap">
                  {item.delta}
                </span>
              </div>
              <div className="mt-5 font-heading text-3xl font-bold text-foreground-950">
                {item.count}
              </div>
              <div className="mt-1 text-sm font-label font-medium text-foreground-800">
                {item.label}
              </div>
              <p className="mt-3 text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                {item.desc}
              </p>
              <div className="mt-5 h-1 w-full rounded-full bg-background-200 overflow-hidden">
                <div
                  className={`h-full rounded-full ${toneBar[item.tone]}`}
                  style={{
                    width:
                      item.key === "debunked"
                        ? "86%"
                        : item.key === "reversed"
                          ? "62%"
                          : item.key === "pending"
                            ? "48%"
                            : "34%",
                  }}
                />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}